module.exports = __webpack_public_path__ + "img/icon_gas.bc137e11.png";